<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false"  />
        <div class="content-wrapper">
            <el-row>
                <div class="card-top is-hover-shadow">
                    <div class="card-top-left">
                        <div class="top">2022/哈尔滨-国庆活动/Cross-Channel&CR&Club&KTV&bar</div>
                        <div class="bottom">
                            <div class="left">活动PR：PR002 - 哈尔滨 - 国庆活动PR</div>
                            <div class="right">哈尔滨</div>
                        </div>
                    </div>
                    <div class="card-top-right">
                        <div class="text-time">
                            活动执行时间：2022.01.16  至  2022.02.13
                        </div>
                    </div>
                </div>
            </el-row>
            <el-row>
                <el-col :span="6" class="content-left">
                <div class="trade-container">
                    <el-card class="trade-nav-panel">
                    <div slot="header" class="clearfix">
                        <span class="panel-header">提报状态</span>
                    </div>
                    <el-menu router :default-active="$route.path" active-text-color="#101010" text-color="#999999">
                        <el-menu-item index="/gameplan/activity-salePlace/all" >
                        <span slot="title">全部</span>
                        </el-menu-item>
                        <el-menu-item index="/gameplan/activity-salePlace/approvalWait">
                        <span slot="title">待审批</span>
                        </el-menu-item>
                        <el-menu-item index="/gameplan/activity-salePlace/approvalPending">
                        <span slot="title">审批中</span>
                        </el-menu-item>
                        <el-menu-item index="/gameplan/activity-salePlace/approvalFinsh" >
                        <span slot="title">已通过</span>
                        </el-menu-item>
                    </el-menu>
                    </el-card>
                </div>
                </el-col>
                <el-col :span="18" class="content-right" >
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <el-form-item class="item" prop="storeName">
                            <el-input v-model="searchForm.storeName" placeholder="门店名称" size="small" suffix-icon="el-icon-search"></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="selectBrand">
                            <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectChannel">
                            <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="fieldSurveystatus">
                            <el-select v-model="searchForm.fieldSurvey" placeholder="场勘状态" size="small" clearable>
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="buildStatus">
                            <el-select v-model="searchForm.buildStatus" placeholder="搭建状态" size="small" clearable>
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="implementStatus">
                            <el-select v-model="searchForm.implementStatus" placeholder="执行状态" size="small" clearable>
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item-btn">
                            <el-button type="danger" size="small" @click="submitForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="card-box" >
                        <div class="card is-hover-shadow" v-for="(item) in 5" :key="item" >
                            <div class="left">
                                <img src="" alt="">
                            </div>
                            <div class="center">
                                <div class="center-top">李哥龙虾烧烤店</div>
                                <div class="center-main">李老板 - 15801010101</div>
                                <div class="center-bottom">
                                    <div class="center-bottom-left">渠道：Cross-Channel</div>
                                    <div class="center-bottom-right">活动形式：地标</div>
                                </div>
                            </div>
                            <div class="right">
                                <div class="right-top">已通过</div>
                                <div class="right-main">广东省梅州市0002号</div>
                                <div class="right-bottom" @click="viewDetail()">查看详情</div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination">
                        <el-pagination
                        background
                        :total="total"
                        layout="total, prev, pager, next"
                        :current-page="queryParams.page"
                        :page-size="queryParams.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'

    import ContentHeader from '@/components/content-header'

    export default {
      name: 'activity-salePlace',
      components: {
        ContentHeader,
      },
      data () {
        return {
            total:100,
            queryParams: {
                page: 1,
                pageSize: 10,
                applyType: '',
                applyStatus: '',
                solutionStatus: '',
                acceptanceStatus: '',
                requirementStatus: '',
                executionStatus: '',
                isOwner: '',
                pledgePaid: '',
                applyClientLevel: '',
                queryType: '',
                queryRegionCode: '',
                queryBuCode: '',
                tradeStackWeek: '',
                tradeStackWeekStatus: '',
                waitClockIn: '',
                stackSpecs: '',
                applyNumber: '',
                vendorName: '',
                pocName: '',
                pocCode: '',
                execType: '',
                execTypeSub: '',
                isAll: '',
                keyword: '',
                orderCol: '',
                orderMethod: '',
                applyTypeTemp: '',
                applyStatusTemp: '',
                applySubStatusTemp: '',
                clientType: '',
                applyStatusList: '',
                waitSupplement: ''
            },
            searchForm: {
                storeName: '', // 门店名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                fieldSurveystatus: '', // 场勘状态
                buildStatus: '', // 搭建状态
                implementStatus: '', // 执行状态
            },
            options: [
            {
            value: '1',
            label: '黄金糕'
            }, {
            value: '2',
            label: '双皮奶'
            }, {
            value: '3',
            label: '蚵仔煎'
            }, {
            value: '4',
            label: '龙须面'
            }, {
            value: '5',
            label: '北京烤鸭'
            }
        ],
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        $route (to, from) {
            console.log(to.params.activityType,'to');
            console.log(from.params.activityType,'from');
        }
      },
      created () {
        console.log(this.$route.params.activityType,'created-------activityType');
      },
      mounted () {
      },
      methods: {
        handleCurrentChange (val) {
          this.queryParams.page = val
          console.log(val,'page');
        },
        submitForm (val) {
            console.log(this.searchForm,'search提交');
        this.$refs.searchForm.validate((valid) => {
          if (valid) {
            console.log(this.searchForm,'valid------search提交');

          } else {
            console.log('error submit!!');
            return false;
          }
        });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            // this.$refs.searchForm.resetFields();
            console.log(this.searchForm,'重置后');
        },
        viewDetail () {
            this.$router.push({path:'/gameplan/salePlace-detail',query:{prId:'1'}})
        }
      }
    }
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
    //   min-height: 400px;
      margin: 0 auto;
      background: $base-white;
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }

      ::v-deep .el-card__body {
        padding: 0;
      }

      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }

      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }

    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;

    //   .content-left,
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            // margin-left: 60px;
            .searchForm {
                width: 100%;
                .item {
                    width:114px;
                }
                .item-btn {
                    margin-left: 20px;
                }
            }
        }
        .card-box {
            .card {
                height: 105px;
                padding: 20px;
                background-color: #FFFFFF ;
                border-radius: 10px;
                font-size: 14px;
                margin-bottom: 20px;
                display: flex;
                .left {
                    width: 110px;
                    height: 110px;
                    border-radius: 8px;
                    background-color: #CD1231;
                }
                .center {
                    text-align: left;
                    margin-left: 17px;
                    .center-top {
                        height: 34px;
                        line-height: 34px;
                        font-size: 22px;
                        color: #101010;
                        font-family: SourceHanSansSC-medium;

                    }
                    .center-main {
                        height: 23px;
                        line-height: 23px;
                        font-size: 14px;
                        color: #999999;
                        margin-bottom: 14px;
                        margin-top: 3px;
                    }
                    .center-bottom {
                        display: flex;
                        height: 32px;
                        line-height: 32px;
                        .center-bottom-left {
                            font-size: 16px;
                            color: #101010;
                            margin-right: 5px;

                        }
                        .center-bottom-right {
                            height: 20px;
                            line-height: 20px;
                            border-radius: 4px;
                            background-color: #FFFFFF;
                            color: #CD1231;
                            font-size: 12px;
                            text-align: center;
                            font-family: Microsoft Yahei;
                            border: 1px solid #CD1231;
                            padding: 1px 5px;
                            margin-top: 4px;
                        }


                    }
                }
                .right {
                    flex: 1;
                    text-align: right;
                    .right-top {
                        font-size: 16px;
                        font-family: SourceHanSansSC-medium;
                        color: #CD1231;
                    }
                    .right-main {
                        height: 55px;
                        line-height: 55px;
                        font-size: 14px;
                        color: #101010;
                    }
                    .right-bottom {
                        width: 84px;
                        height: 32px;
                        line-height: 32px;
                        margin-left: 385px;
                        border-radius: 4px;
                        background-color: #FFFFFF;
                        font-size: 14px;
                        text-align: center;
                        font-family: Microsoft Yahei;
                        border: 1px solid #CD1231;
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
      .card-top {
        height: 53px;
        line-height: 20px;
        border-radius: 10px;
        margin-left: 26px;
        padding: 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        color: #101010;
        font-family: Roboto;
        display: flex;
        justify-content: flex-start;
        .card-top-left {
            .top {
                height: 29px;
                line-height: 29px;
                color: #101010;
                font-size: 20px;
                text-align: left;
                font-family: SourceHanSansSC-medium;
                margin-bottom: 5px;
            }
            .bottom {
                display: flex;
                justify-content: flex-start;
                .left {
                    font-size: 16px;
                    margin-right: 11px;
                    height: 24px;
                    line-height: 24px;
                }
                .right {
                    width: 72px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 4px;
                    font-size: 14px;
                    background-color: #FFFFFF;
                    color: #539EFE;
                    border: 1px solid #539EFE;
                    text-align: center;
                    font-family: Microsoft Yahei;
                }

            }

        }
        .card-top-right {
            flex: 1;
            text-align: right;
            height: 20px;
            line-height: 20px;
            margin-top: 40px;
            color: #999999;
        }
      }
    }
</style>
